import React from 'react';

interface HtmlContentProps {
  html: string;
  className?: string;
}

/**
 * A component that safely renders HTML content from text resources
 */
export const HtmlContent: React.FC<HtmlContentProps> = ({ html, className }) => {
  return (
    <div 
      className={className} 
      dangerouslySetInnerHTML={{ __html: html }} 
    />
  );
};
